// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3i3Z_","additionalInfo":"AgreementModal_additionalInfo__1Knsa"};